import { render } from "./ForThePure.vue?vue&type=template&id=09646bd8&scoped=true&ts=true"
import script from "./ForThePure.vue?vue&type=script&lang=ts"
export * from "./ForThePure.vue?vue&type=script&lang=ts"

import "./ForThePure.vue?vue&type=style&index=0&id=09646bd8&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09646bd8"]])

export default __exports__